import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import Layout from "@/components/Layout";
import { toast } from "sonner";
import { CircleNotch, ArrowLeft, Printer, PencilSimple } from "@phosphor-icons/react";
import CoachingBlueprint from "@/components/blueprints/CoachingBlueprint";
import ShareButton from "@/components/ShareButton";
import ExportPdfButton from "@/components/ExportPdfButton";

export default function CoachingView() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [doc, setDoc] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const res = await api.get(`/documents/${id}`);
        setDoc(res.data);
      } catch {
        toast.error("Document not found");
        navigate("/dashboard");
      } finally {
        setLoading(false);
      }
    })();
  }, [id, navigate]);

  if (loading || !doc)
    return <Layout><div className="flex items-center justify-center py-40 text-slate-400"><CircleNotch size={28} className="animate-spin" /></div></Layout>;

  return (
    <Layout>
      <div className="max-w-3xl mx-auto w-full py-8 px-6 lg:px-10 print:px-0 print:py-0 print:max-w-none">
        <div className="flex flex-wrap items-start justify-between gap-4 print:block">
          <div>
            <button data-testid="back-to-dashboard" onClick={() => navigate("/dashboard")} className="inline-flex items-center gap-1.5 text-sm text-slate-500 hover:text-slate-800 mb-2 print:hidden">
              <ArrowLeft size={16} /> Workspace
            </button>
            <p className="text-xs font-semibold tracking-[0.12em] uppercase text-emerald-700">4-Step Coaching Feedback</p>
            <h1 className="mt-1 text-2xl sm:text-3xl font-bold tracking-tight text-slate-900">{doc.title}</h1>
          </div>
          <div className="flex items-center gap-2 print:hidden">
            <ShareButton docId={id} initialToken={doc.share_token} />
            <ExportPdfButton docId={id} />
            <button data-testid="edit-coaching-button" onClick={() => navigate(`/coaching/${id}`)}
              className="inline-flex items-center gap-2 rounded-sm border border-slate-300 bg-white px-4 py-2.5 text-sm font-medium text-slate-700 hover:bg-slate-50">
              <PencilSimple size={16} /> Edit
            </button>
            <button data-testid="export-pdf-button" onClick={() => window.print()}
              className="inline-flex items-center gap-2 rounded-sm bg-slate-900 px-4 py-2.5 text-sm font-medium text-white hover:bg-slate-800">
              <Printer size={18} /> Print / PDF
            </button>
          </div>
        </div>

        <div className="mt-6"><CoachingBlueprint doc={doc} /></div>

        <div className="hidden print:block mt-8 pt-4 border-t border-slate-300 font-mono text-xs text-slate-400">
          MODUS · 4-Step Coaching Feedback · {doc.title} · Generated {new Date().toLocaleString()}
        </div>
      </div>
    </Layout>
  );
}
